import { Component, type ReactNode } from "react";

interface PreviewBoundaryProps {
  /** Rendered instead of the children when a card crashes at render time. */
  fallback: ReactNode;
  children: ReactNode;
}

/**
 * Error boundary around a typed preview card. The payload is attacker-
 * influenceable third-party data — a render-time crash in a card must degrade
 * to the text-preview fallback instead of killing the whole chat thread.
 */
export class PreviewBoundary extends Component<PreviewBoundaryProps, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  render(): ReactNode {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
